export const environment = {
  production: true,
  buildId: '2676267645518281',
  configFile: 'config.json',
};
